var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vacation-type-modal",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("remove-type-modal", {
        ref: "removeTypeModal",
        on: { remove: _vm.removeType },
      }),
      _c(
        "c-sidesheet",
        {
          attrs: {
            active: _vm.active,
            title: _vm.id ? "Редактирование типа отпуска" : "Новый тип отпуска",
          },
          on: { close: _vm.close },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "div",
                    { attrs: { id: "vacation-type-delete-button-wrapper" } },
                    [
                      _vm.id
                        ? _c("c-button-2", {
                            staticClass: "vacation-type-form__save",
                            attrs: {
                              disabled: !_vm.canDelete,
                              icon: { icon: "trash", color: "secondary" },
                              label: "Удалить",
                              size: "small",
                            },
                            on: { click: _vm.remove },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          !_vm.canDelete
            ? _c(
                "b-popover",
                {
                  attrs: {
                    placement: "top",
                    container: "app",
                    boundary: "window",
                    target: "vacation-type-delete-button-wrapper",
                    triggers: "hover blur",
                  },
                },
                [
                  _c("error-feedback", {
                    staticClass: "m-0 empty-category-tooltip",
                    attrs: {
                      text: 'В данный момент удаление невозможно, так как тип отпуска используется в разделе "Графики отпусков и больничных"',
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "vacation-type-form" }, [
            _c("div", { staticClass: "vacation-type-form__form" }, [
              _c(
                "div",
                { staticClass: "vacation-type-form__name" },
                [
                  _c("c-input-2", {
                    attrs: {
                      "floating-label": "Наименование",
                      required: _vm.nameError,
                      "required-condition": _vm.nameError,
                      "required-message": _vm.nameError,
                      "required-mark": true,
                      disabled: _vm.isSick,
                      clearable: true,
                      "max-length": 500,
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vacation-type-form__description" },
                [
                  _c("c-textarea", {
                    ref: "description",
                    attrs: {
                      "floating-label": "Описание",
                      clearable: true,
                      "max-length": 500,
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "vacation-type-form__row" }, [
                _c(
                  "div",
                  { staticClass: "vacation-type-form__color" },
                  [
                    _c("color-select", {
                      ref: "color",
                      attrs: {
                        validate: _vm.submitted,
                        "default-color": "#DFE4EF",
                        disabled: _vm.isSick,
                        label: "Цвет в графике отпусков",
                      },
                      model: {
                        value: _vm.form.color,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "color", $$v)
                        },
                        expression: "form.color",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vacation-type-form__code" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        "floating-label": "Код для табеля",
                        clearable: true,
                        "max-length": 2,
                      },
                      model: {
                        value: _vm.form.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "code", $$v)
                        },
                        expression: "form.code",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "vacation-type-form__actions" },
              [
                _c("c-button-2", {
                  staticClass: "vacation-type-form__reset",
                  attrs: { size: "large", label: "Отменить" },
                  on: { click: _vm.close },
                }),
                _c("c-button-2", {
                  staticClass: "vacation-type-form__save",
                  attrs: {
                    label: "Сохранить",
                    color: "primary",
                    size: "large",
                    disabled: _vm.pending,
                  },
                  on: { click: _vm.submit },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }